import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "trainingId",
    "datesFieldsTemplate",
    "locationInPersonFieldsTemplate",
    "locationVirtualClassroomFieldsTemplate",
    "datesFieldsContainer",
    "locationFieldsContainer",
    "removeTrainingSessionDayButton"
  ]

  updateRelatedToTrainingFields () {
    const trainingId = this.trainingIdTarget.value

    if (trainingId) {
      this.buildTrainingSessionDays(trainingId)
      this.updateLocationFields(trainingId)
    }
  }

  buildTrainingSessionDays (trainingId) {
    this.datesFieldsContainerTarget.innerHTML = ""

    const clone = this.datesFieldsTemplateTarget.content.cloneNode(true)
    this.datesFieldsContainerTarget.appendChild(clone)

    fetch(`/api/v1/trainings/${trainingId}/training_session_day_templates`)
      .then(response => response.json())
      .then(data => {
        const nestedForm = document.getElementById("nested-form-training-session-days")
        const addTrainingSessionDayButton = nestedForm.querySelector("button[data-action='training-sessions--nested-form-training-session-days#add']")

        this.removeTrainingSessionDayButtonTargets.forEach(button => {
          button.click()
        })

        data.data.forEach(async (_, index) => {
          // Necessary to add a small delay because it uses timestamps behind the scenes
          await new Promise(resolve => setTimeout(resolve, 1))
          addTrainingSessionDayButton.click()
        })
      })
      .catch(error => {
        console.error(error)
      })
  }

  updateLocationFields (trainingId) {
    this.locationFieldsContainerTarget.innerHTML = ""

    fetch(`/api/v1/trainings/${trainingId}`)
      .then(response => response.json())
      .then(data => {
        if (data.data.attributes.is_in_person) {
          const clone = this.locationInPersonFieldsTemplateTarget.content.cloneNode(true)
          this.locationFieldsContainerTarget.appendChild(clone)
        } else { // is_virtual_classroom
          const clone = this.locationVirtualClassroomFieldsTemplateTarget.content.cloneNode(true)
          this.locationFieldsContainerTarget.appendChild(clone)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }
}
